import language from "../language";
import { clearStorage, getStorage } from "../utils/storage";

const onLogout = async () => {
  const user = await getStorage();
  await clearStorage();

  window.location.href = user.role === "donor" ? "/login" : "/admin-login";
};

const nonAuthMenus = (lng = "english") => [
  {
    name: language[lng].home,
    route: "/landing",
    access: ["public"],
  },
  {
    name: language[lng].who_can_give_blood,
    route: "/landing#giveBlood",
    access: ["public"],
  },
  {
    name: language[lng].how_works,
    route: "/landing#howWorks",
    access: ["public"],
  },
  {
    name: language[lng].hospitals_or_sites,
    route: "/landing#findSites",
    access: ["public"],
  },
  {
    name: language[lng].partners,
    route: "/landing#partners",
    access: ["public"],
  },
  {
    name: language[lng].contact_us,
    route: "/landing#contactUs",
    access: ["public"],
  },
];

const authMenus = (lng = "english", user = {}) => {
  const isDonor = user.role === "donor" || user.account_type === "donor";

  if (isDonor) {
    return [
      {
        name: language[lng].settings,
        icon: "settings",
        onPress: () => (window.location.href = "/user/settings"),
      },
      {
        name: language[lng].logout,
        onPress: () => onLogout(),
        icon: "logout",
      },
    ];
  }

  return [
    {
      name: language[lng].settings,
      icon: "settings",
      onPress: () => (window.location.href = "/dashboard/settings"),
    },
    {
      name: language[lng].workspace,
      icon: "grid_view",
      onPress: () => (window.location.href = "/workspace"),
    },
    {
      name: language[lng].logout,
      onPress: () => onLogout(),
      icon: "logout",
    },
  ];
};

export { nonAuthMenus, authMenus };
